import React from "react";
import { Box, Typography } from "@mui/material";
import RadioButtonGroup from "../../shared/components/formfields/RadioButtonGroup";
import { useRadioGroup } from "../../shared/hook/useRadioGroup";
import MilestoneCourses from "./addcourses/offlineCourses/MilestoneCourses";
import RecurringCourses from "./addcourses/offlineCourses/RecurringCourses";
import PrizeCourses from "./addcourses/offlineCourses/PrizeCourses";
import ProCourses from "./addcourses/offlineCourses/ProCourses";
import { NormalContainerWithHeader } from "../../shared/components/student/NormalComponent";
import RecurringOnlineCourses from "./addcourses/onlineCourses/RecurringOnlineCourses";

// Mapping for Offline Components
const offlineOptionComponents = {
    recurring: <RecurringCourses />,
    milestone: <MilestoneCourses />,
    prize: <PrizeCourses />,
    pro: <ProCourses />,
};

// Mapping for Online Components
const onlineOptionComponents = {
    milestone: <div>Online milestone Component</div>,
    price: <div>Online price Component</div>,
};

// Mapping for Recurring Sub-options (Online)
const recurringSubOptionComponents = {
    oneToOne: <RecurringOnlineCourses  onlineType={"1-to-1"}/>,
    oneToMany: <RecurringOnlineCourses onlineType={"1-to-many"}/>,
};

const AddCourses = () => {
    // Level 1: Course Type
    const courseOptions = [
        { label: "Offline", value: "offline" },
        { label: "Online", value: "online" },
    ];
    const { selectedOption: courseType, handleChange: handleCourseTypeChange } =
        useRadioGroup("offline");

    // Offline Options
    const offlineOptions = [
        { label: "Recurring", value: "recurring" },
        { label: "Milestone", value: "milestone" },
        { label: "Prize", value: "prize" },
        { label: "Pro", value: "pro" },
    ];
    const { selectedOption: offlineSelected, handleChange: handleOfflineChange } =
        useRadioGroup("recurring");

    // Online Options
    const onlineOptions = [
        { label: "Recurring", value: "recurring" },
        { label: "Milestone", value: "milestone" },
        { label: "Price", value: "price" },
    ];
    const { selectedOption: onlineSelected, handleChange: handleOnlineChange } =
        useRadioGroup("recurring");

    // Online Recurring Sub-options
    const recurringSubOptions = [
        { label: "One-to-One", value: "oneToOne" },
        { label: "One-to-Many", value: "oneToMany" },
    ];
    const {
        selectedOption: recurringSubSelected,
        handleChange: handleRecurringSubChange,
    } = useRadioGroup("oneToOne");

    // Feature Yes/No (global toggle)
    const featureOptions = [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
    ];
    const { selectedOption: featureSelected, handleChange: handleFeatureChange } =
        useRadioGroup("no");

    // API Payload Example
    const apiPayload = {
        courseType,
        offlineOption: offlineSelected,
        onlineOption: onlineSelected,
        recurringSubOption: recurringSubSelected,
        feature: featureSelected,
    };

    // Decide which component to render
    const renderSelectedComponent = () => {
        if (courseType === "offline") {
            return offlineOptionComponents[offlineSelected] || null;
        }

        if (courseType === "online") {
            if (onlineSelected === "recurring") {
                return recurringSubOptionComponents[recurringSubSelected] || null;
            }
            if (onlineSelected === "milestone") {
                return onlineOptionComponents["milestone"];
            }
            if (onlineSelected === "price") {
                return onlineOptionComponents["price"];
            }
        }
        return null;
    };

    return (
        <NormalContainerWithHeader>
            {/* Level 1: Course Type */}
            <Typography variant="subtitle1" mb={1}>
                Course Type
            </Typography>
            <RadioButtonGroup
                options={courseOptions}
                value={courseType}
                onChange={handleCourseTypeChange}
                row
            />

            {/* OFFLINE Options */}
            {courseType === "offline" && (
                <Box mt={2}>
                    <Typography variant="subtitle2" mb={1}>
                        Offline Options
                    </Typography>
                    <RadioButtonGroup
                        options={offlineOptions}
                        value={offlineSelected}
                        onChange={handleOfflineChange}
                        row
                    />
                </Box>
            )}

            {/* ONLINE Options */}
            {courseType === "online" && (
                <Box mt={2}>
                    <Typography variant="subtitle2" mb={1}>
                        Online Options
                    </Typography>
                    <RadioButtonGroup
                        options={onlineOptions}
                        value={onlineSelected}
                        onChange={handleOnlineChange}
                        row
                    />

                    {/* Online Recurring → Show Sub-options */}
                    {onlineSelected === "recurring" && (
                        <Box mt={3}>
                            <Typography variant="subtitle2" mb={1}>
                                Recurring Options
                            </Typography>
                            <RadioButtonGroup
                                options={recurringSubOptions}
                                value={recurringSubSelected}
                                onChange={handleRecurringSubChange}
                                row
                            />
                        </Box>
                    )}
                </Box>
            )}

            {/* Feature Yes/No (always just below radios, above component) */}
            <Box mt={3}>
                <Typography variant="subtitle2" mb={1}>
                    Feature
                </Typography>
                <RadioButtonGroup
                    options={featureOptions}
                    value={featureSelected}
                    onChange={handleFeatureChange}
                    row
                />
            </Box>

            {/* Render main component (Offline/Online sub) */}
            <Box mt={3}>{renderSelectedComponent()}</Box>
        </NormalContainerWithHeader>
    );
};

export default AddCourses;

